import { memo } from "react";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { ThemedContentCopyIcon } from "assets/CXFIcons/Designer/ContextActions";
import { useTranslation } from "react-i18next";

const ButtonCopyNode = ({ copyNode }) => {
  const { t } = useTranslation("flowDesigner");
  return (
    <Tooltip title={t("buttons.copy_node")} placement="top">
      <IconButton size="small" style={{ width: "100%", height: "100%" }} onClick={copyNode}>
        <ThemedContentCopyIcon width="20px" height="20px" color="currentColor" />
      </IconButton>
    </Tooltip>
  );
};

export default memo(ButtonCopyNode);
